import React from 'react'
import * as UI from 'ui'
import AdminPage from 'pages/app/AdminPage'
import { Translation, Translator } from '@morningtrain/react-translations'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { SelectedDepartmentFilter } from 'support/filters'
import { Model } from '@morningtrain/react-resources'
import PeriodFilterSyncedWithPage from 'support/filters/PeriodFilterSyncedWithPage'
import AvgBasketSizeTables from 'pages/app/economy/partials/AvgBasketSizeTables'
import AvgBasketSizeSummaryWidget from 'widgets/economy/partials/AvgBasketSizeSummaryWidget'
import AverageBasketSizeLineChartLoader from 'widgets/charts/loaders/AverageBasketSizeLineChartLoader'
import CookieFilter from "support/filters/CookieFilter";
import {Env} from "@morningtrain/helpers";
import AvgBasketSizeSummaryCalculatedWidget from "widgets/economy/partials/AvgBasketSizeSummaryCalculatedWidget";

export default function AvgBasketSize (props) {
  const hasCalculatedBasketSize = Env.get('globals.has_calculated_basket_size');

  return (
    <AdminPage>
      <Translator namespace='economy.pages.avg_basket_size'>
        <UI.PageHeader title={<TranslatedTitle />}>
          <PeriodFilterSyncedWithPage selectors={['yesterday', 'today', 'this_week', 'this_month', 'this_year']}/>
        </UI.PageHeader>

        <UI.CardGroup>

          <Model resourceName='economy' operationName='average_basket_size_development'>
            <SelectedDepartmentFilter />
            <CookieFilter name='period' cookieKey='page.filters.period' />

            <div className='space-x-4 flex'>
              {hasCalculatedBasketSize ?
                <AvgBasketSizeSummaryCalculatedWidget className='w-1/3' />
                : <AvgBasketSizeSummaryWidget className='w-1/3' />
              }
              <UI.Card className='w-2/3'>
                <UI.CardHeader>
                  <UI.SecondaryHeading width='w-1/2'>
                    <Translation name='chart_title' />
                  </UI.SecondaryHeading>
                  <UI.Legend>
                    <UI.LegendItem colorHex='#616DE1'>
                      <Translation name='generic.total' />
                    </UI.LegendItem>
                    <UI.LegendItem colorHex='#af8c21'>
                      <Translation name='generic.without_discounts' />
                    </UI.LegendItem>
                    <UI.LegendItem colorHex='#E5483F'>
                      <Translation name='generic.inhouse' />
                    </UI.LegendItem>
                    <UI.LegendItem colorHex='#6d21af'>
                      <Translation name='generic.takeaway' />
                    </UI.LegendItem>
                  </UI.Legend>
                </UI.CardHeader>
                <div className='w-full h-96'>
                  <AverageBasketSizeLineChartLoader />
                </div>
              </UI.Card>
            </div>

            <AvgBasketSizeTables />

          </Model>
        </UI.CardGroup>
      </Translator>
    </AdminPage>
  )
}
